import { render, staticRenderFns } from "./ImportReportDP.vue?vue&type=template&id=dc648806&"
import script from "./ImportReportDP.vue?vue&type=script&lang=js&"
export * from "./ImportReportDP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc648806')) {
      api.createRecord('dc648806', component.options)
    } else {
      api.reload('dc648806', component.options)
    }
    module.hot.accept("./ImportReportDP.vue?vue&type=template&id=dc648806&", function () {
      api.rerender('dc648806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directPayments/sendbox/ImportReportDP.vue"
export default component.exports